import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import AltMap from '../AltMap';

const GoogleMapPropTypes = {
  loaded: PropTypes.bool.isRequired, // Lets this component know that the Google API is ready
  loadMap: PropTypes.func.isRequired, // Method to invoke when the map is ready to load
  isMobile: PropTypes.bool.isRequired, // True when the app is loaded on a handheld sized device
  editing: PropTypes.bool.isRequired, // If the user is editing their trip
  zoom: PropTypes.number.isRequired, // Default zoom level of the map
  fieldsLength: PropTypes.number.isRequired, // Number of places/fields in a users trip
  directionsLoaded: PropTypes.bool.isRequired, // If the directions have successfully returned from API
  showAltMap: PropTypes.bool.isRequired, // True when user has unlocked easter egg
  outOfRangeLabel: PropTypes.string.isRequired, // Warning message to user when trip is not yet possible
};

const GoogleMapDefaultProps = {};

class GoogleMap extends Component {
  componentDidMount() {
    const { loadMap } = this.props;

    window.setTimeout(() => {
      loadMap(this.map);
    }, 300);
  }

  componentDidUpdate(prevProps) {
    const { loaded, zoom } = this.props;
    const { loadMap } = this.props;

    if (prevProps.loaded !== loaded && zoom !== 0) {
      loadMap(this.map);
    }
  }

  render() {
    // eslint-disable-next-line arrow-parens
    const mapRef = el => {
      this.map = el;
    };
    const {
      isMobile,
      editing,
      fieldsLength,
      directionsLoaded,
      showAltMap,
      outOfRangeLabel,
    } = this.props;

    if (showAltMap) {
      return <AltMap label={outOfRangeLabel} />;
    }

    return (
      <div>
        <div
          className={classNames('gmap', {
            'gmap--collapse':
              isMobile && !editing && fieldsLength <= 2 && directionsLoaded,
            'gmap--collapse-more':
              isMobile && !editing && fieldsLength > 2 && directionsLoaded,
          })}
          ref={mapRef}
        />
      </div>
    );
  }
}

GoogleMap.propTypes = GoogleMapPropTypes;

GoogleMap.defaultProps = GoogleMapDefaultProps;

export default GoogleMap;
